import { CommonColors } from "../../../types/colors";
import { ButtonProps } from "../../buttons/button";

export const colorScheme: Record<
  CommonColors,
  {
    containerClassName: string;
    titleClassName: string;
    descriptionClassName: string;
    ctaVariant?: ButtonProps["variant"];
  }
> = {
  [CommonColors.Light]: {
    containerClassName: "bg-light",
    titleClassName: "text-primary",
    descriptionClassName: "text-dark",
    ctaVariant: "primary-outline",
  },
  [CommonColors.Neutral]: {
    containerClassName: "bg-neutral",
    titleClassName: "text-primary",
    descriptionClassName: "text-dark",
    ctaVariant: "neutral",
  },
  [CommonColors.NeutralLight]: {
    containerClassName: "bg-neutral-light",
    titleClassName: "text-primary",
    descriptionClassName: "text-dark",
    ctaVariant: "neutral",
  },
  [CommonColors.Dark]: {
    containerClassName: "bg-dark",
    titleClassName: "text-light",
    descriptionClassName: "text-light",
    ctaVariant: "light-outline",
  },
  [CommonColors.Primary]: {
    containerClassName: "bg-primary",
    titleClassName: "text-light",
    descriptionClassName: "text-light",
    ctaVariant: "light-outline",
  },
  [CommonColors.Glass]: {
    containerClassName: "bg-glass",
    titleClassName: "text-dark",
    descriptionClassName: "text-dark",
    ctaVariant: "neutral",
  },
  [CommonColors.Wood]: {
    containerClassName: "bg-wood",
    titleClassName: "text-dark",
    descriptionClassName: "text-dark",
    ctaVariant: "neutral",
  },
  [CommonColors.Stone]: {
    containerClassName: "bg-stone",
    titleClassName: "text-dark",
    descriptionClassName: "text-dark",
    ctaVariant: "neutral",
  },
  [CommonColors.Materia]: {
    containerClassName: "bg-materia",
    titleClassName: "text-dark",
    descriptionClassName: "text-dark",
    ctaVariant: "neutral",
  },
  [CommonColors.Metal]: {
    containerClassName: "bg-metal",
    titleClassName: "text-dark",
    descriptionClassName: "text-dark",
    ctaVariant: "neutral",
  },
};
